"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _unsplashHelper = require("@eig-builder/core-utils/helpers/unsplash-helper");

var _imageCanvasSingle = _interopRequireDefault(require("./image-canvas-single"));

require("../progressive-file-loader/style/progressive-file-loader.scss");

var _imageLibrary = require("../../image-library");

var ImageCanvas = function ImageCanvas(_ref) {
  var files = _ref.files,
      uploadStates = _ref.uploadStates,
      progressStates = _ref.progressStates,
      onSelectbase64 = _ref.onSelectbase64;

  var _React$useContext = _react["default"].useContext(_imageLibrary.ImageLibraryContext),
      onUseImages = _React$useContext.onUseImages;

  var localOnSelect = function localOnSelect(url, uploaded) {
    if (uploaded) {
      var mappedUrl = {
        original: url,
        thumbnail: url,
        source: 'uploads',
        sizes: (0, _unsplashHelper.makeUrlsSizes)(null, url)
      };
      onUseImages(mappedUrl, true);
    }
  };

  _react["default"].useEffect(function () {
    if ((uploadStates === null || uploadStates === void 0 ? void 0 : uploadStates[0]) && files.length === 1) {
      localOnSelect(files[0].url, true);
    }
  }, [uploadStates, files, localOnSelect]); // We are selecting the first image when there is only one and we have a base64 return.
  // The rendering should stop because we are closing


  if (files.length === 1) {
    return null;
  }

  return files.map(function (file, key) {
    var uploaded = uploadStates[key];
    return /*#__PURE__*/_react["default"].createElement(_imageCanvasSingle["default"], {
      progress: progressStates[key],
      file: file,
      key: key,
      useBase64Return: onSelectbase64,
      onSelect: localOnSelect,
      uploaded: uploaded
    });
  });
};

ImageCanvas.propTypes = {
  files: _propTypes["default"].array.isRequired,
  uploadStates: _propTypes["default"].array,
  progressStates: _propTypes["default"].array,
  onSelectbase64: _propTypes["default"].func
};
var _default = ImageCanvas;
exports["default"] = _default;